/** @format */

import { RootState } from "../store/store";

export const selectPaymentMethods = (state: RootState) =>
	state.paymentMethod?.paymentMethods || [];

export const selectDefaultPaymentMethod = (state: RootState) =>
	state.paymentMethod?.defaultPaymentMethod || null;

export const selectPaymentMethodLoading = (state: RootState) =>
	state.paymentMethod?.isLoading || false;

export const selectPaymentMethodError = (state: RootState) =>
	state.paymentMethod?.error || null;

export const selectPaymentMethodSuccess = (state: RootState) =>
	state.paymentMethod?.successMessage || null;
